import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import NewsletterEmail from '../forms/NewsletterEmail';
import Header from '../headers/Header';

// import MainLayout from '../layouts/Main';
import styles from '../../../styles/pages/form.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const NewsletterPage = ({ page, className }) => {
    const history = useHistory();
    const location = useLocation();
    const route = useUrlGenerator();

    const onComplete = useCallback(() => {
        // history.push(route('home'));
    }, [history, route]);

    useScrollToTop(location);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Header className={styles.header} page={page} />
            <div
                className={styles.inner}
                style={{
                    justifyContent: 'center',
                }}
            >
                <NewsletterEmail className={styles.newsletter} onComplete={onComplete} />
            </div>
        </div>
    );
};
NewsletterPage.propTypes = propTypes;
NewsletterPage.defaultProps = defaultProps;

export default NewsletterPage;
